'use strict';

module.exports =
	'<a class="ad-component--link <%= className %>"' +
		'<% if(id) {%> id="<%= id %>"<%}%>' +
		'<% if(value) {%> attr-value="<%= value %>"<%}%>' +
		'<% if(clickFunction) {%> onClick="<%= clickFunction %>"<%}%>' +
		'<% if(url) {%> href="<%= url %>"<%}%>>' +
		'<%= label %>' +
	'</a>';



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/templates/ad-link.tpl.js
// module id = 10
// module chunks = 0